// src/api/vacationRequestsApi.js

/**
 * Submit a new vacation request
 */
export async function submitVacationRequest(pin, vacationData) {
  try {
    const resp = await fetch('/php/vacation_requests_api.php?action=submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        pin,
        dateFrom: vacationData.dateFrom,
        dateTo: vacationData.dateTo,
        requestType: vacationData.requestType || 'dovolenka',
        notes: vacationData.notes || ''
      })
    });

    if (!resp.ok) {
      const data = await resp.json();
      return { ok: false, error: data.error || `Chyba: HTTP ${resp.status}` };
    }

    const data = await resp.json();
    return data;
  } catch (error) {
    return { ok: false, error: error.message };
  }
}

/**
 * Load vacation requests
 * - If supervisor: loads requests from managed employees
 * - If employee: loads their own requests
 */
export async function loadVacationRequests(pin) {
  try {
    const resp = await fetch(`/php/vacation_requests_api.php?action=list&pin=${encodeURIComponent(pin)}`);

    if (!resp.ok) {
      const data = await resp.json();
      return { ok: false, error: data.error || `Chyba: HTTP ${resp.status}`, requests: [] };
    }

    const data = await resp.json();
    return data;
  } catch (error) {
    return { ok: false, error: error.message, requests: [] };
  }
}

/**
 * Approve a vacation request (supervisor only)
 */
export async function approveVacationRequest(pin, requestId) {
  try {
    const resp = await fetch('/php/vacation_requests_api.php?action=approve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin, requestId })
    });

    if (!resp.ok) {
      const data = await resp.json();
      return { ok: false, error: data.error || `Chyba: HTTP ${resp.status}` };
    }

    const data = await resp.json();
    return data;
  } catch (error) {
    return { ok: false, error: error.message };
  }
}

/**
 * Reject a vacation request (supervisor only)
 */
export async function rejectVacationRequest(pin, requestId, rejectionReason) {
  try {
    const resp = await fetch('/php/vacation_requests_api.php?action=reject', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        pin, 
        requestId,
        rejectionReason: rejectionReason || ''
      })
    });

    if (!resp.ok) {
      const data = await resp.json();
      return { ok: false, error: data.error || `Chyba: HTTP ${resp.status}` };
    }

    const data = await resp.json();
    return data;
  } catch (error) {
    return { ok: false, error: error.message };
  }
}
